export default __webpack_public_path__ + "static/media/q21_01.c6fe4b09.png";